<script lang="ts">
    import { generateId } from "@apps/rewards/utils/generateId";
    import { scrollIntoView } from "@apps/rewards/utils/scrollIntoView";
    import { BehaviorSubject } from "rxjs";
    import { onMount } from "svelte";
    import { scale, slide } from "svelte/transition";

    import BaseButton from "@components/Buttons/BaseButton.svelte";

    //Props
    export let value: string;
    export let isItemMounted$: BehaviorSubject<boolean>;
    export let activeItem$: BehaviorSubject<string>;

    //Optional Props
    export let closeOthers = false;

    //Variables
    let isOpen = false;
    let id = generateId("accordion");

    //Handlers
    const handleToggle = () => {
        isOpen = !isOpen;
        activeItem$.next(value);
    };

    //Component lifecycle
    onMount(() => {
        isItemMounted$.next(true);
    });

    //Reactive Statement
    $: if ($activeItem$ !== value && closeOthers) isOpen = false;
</script>

<div class="gw-rd-accordion__item">
    <BaseButton
        block
        ariaControls={id}
        ariaExpanded={isOpen}
        on:click={handleToggle}
    >
        <slot name="button-content" {isOpen} />
    </BaseButton>
    {#if isOpen}
        <div
            {id}
            role="region"
            class="gw-rd-accordion__item-content"
            transition:slide|local={{ duration: 300 }}
            on:introend={(e) => scrollIntoView(e.currentTarget)}
        >
            <div
                in:scale|local={{
                    duration: 220,
                    delay: 50,
                    start: 0.9,
                }}
            >
                <slot name="accordion-content" />
            </div>
        </div>
    {/if}
</div>
